module.exports = __webpack_public_path__ + "img/SC10-cover-costs.2091378c.svg";